<template>
  <el-dialog class="convert_dialog" :visible.sync="visible" width="800px" append-to-body>
    <p slot="title">价格换算</p>
    <div class="ctn">
      <div class="tip">
        提示：CPD和CPR修改其中一个数据后，另一个将自动算出
        <div class="fr">
          <el-button size="mini" @click="reset">重置</el-button>
        </div>
      </div>
      <div class="main">
        <template v-for="(item, i) in converts">
          <div v-if="item == 'cpm'" :key="i">
            <div class="title">CPR计算公式</div>
            <div class="sub">总价 = 单价 * 已选点位日均流量（预计流量）* 天数 </div>
            <div>
              <el-input size="mini" class="left_input" v-model="cpm.v1" @keyup.native="e => handleNum(e, 'v1')" :disabled="isDis">
                <span slot="append">元&nbsp;&nbsp;=</span>
              </el-input>
              <el-input size="mini" class="right_input" v-model="cpm.v2" @keyup.native="e => handleNum(e, 'v2')" :disabled="isDis">
                <span slot="append">元/千人次 * {{cpmUnit}}千人次/天 * {{daysNum}}天</span>
              </el-input>
              <div class="clear"></div>
            </div>
          </div>
          <div v-if="item == 'cpd'" :key="i">
            <div class="title">CPD计算公式</div>
            <div class="sub">总价 = 单价 * 台数（目标台数）* 天数 </div>
            <div>
              <el-input size="mini" class="left_input" v-model="cpm.v1" @keyup.native="e => handleNum(e, 'v1')" :disabled="isDis">
                <span slot="append">元&nbsp;&nbsp;=</span>
              </el-input>
              <el-input size="mini" class="right_input" v-model="cpm.v3" @keyup.native="e => handleNum(e, 'v3')" :disabled="isDis">
                <span slot="append">元/屏/天 * {{deviceNum}}台 * {{daysNum}}天</span>
              </el-input>
              <div class="clear"></div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div slot="footer">
      <el-button size="mini" @click="visible = false" class="btn">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ConvertDialog",
  props: {
    value: false,
    cpmNum: 0,
    days: 0,
    devices: 0
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    daysNum () {
      return this.days ? this.days - 0 : 0
    },
    cpmUnit () {
      if (!this.daysNum || !this.cpmNum) return 0
      return ((this.cpmNum - 0) / 1000 / this.daysNum).toFixed(2)
    },
    deviceNum () {
      return this.devices ? this.devices - 0 : 0
    },
    isDis () {
      return !this.cpmUnit || !this.daysNum || !this.deviceNum
    },
    payWay () {
      return this.$store.state.order.choosePayWay // 'cpd', 'cpmL', 'cpmT'
    }
  },
  data () {
    return {
      converts: ['cpm', 'cpd'],
      cpm: { v1: '', v2: '', v3: '' },
      timeOut: null
    }
  },
  watch: {
    visible (v) {
      this.cpm.v1 = ''
      this.cpm.v2 = ''
      this.cpm.v3 = ''
    },
    payWay (v) {
      if (v == 'cpd') {
        this.converts = ['cpd', 'cpm']
      } else {
        this.converts = ['cpm', 'cpd']
      }
    }
  },
  methods: {
    inputChange (e, item, changeType) {
      let value = (e.target.value + '').trim()
      if (isNaN(value - 0)) {
        e.target.value = 0
        this.handleValue(item, 0)
        return
      }
      this.handleValue(item, changeType)
    },
    delayFn (fn) {
      if (this.timeOut) return
      else this.timeOut = setTimeout(() => {
        clearTimeout(this.timeOut)
        this.timeOut = null
        fn()
      }, 200)
    },
    handleNum (e, type) {
      let cpmUnit = this.cpmUnit ? this.cpmUnit : 0
      let daysNum = this.daysNum ? this.daysNum : 0
      let deviceNum = this.deviceNum ? this.deviceNum : 0

      let cpmCovert = cpmUnit * daysNum, cpdCovert = deviceNum * daysNum

      this.delayFn(() => {
        let val = e.target.value.trim()
        if (val === '' || isNaN(val)) {
          this.cpm.v1 = ''
          this.cpm.v2 = ''
          this.cpm.v3 = ''
          return
        }
        val = val - 0
        if (val == 0) {
          this.cpm.v1 = 0
          this.cpm.v2 = 0
          this.cpm.v3 = 0
          return
        }
        if (type == 'v1') {
          this.cpm.v2 = cpmCovert != 0 ? (val / cpmCovert).toFixed(2) : '请勾选点位'
          this.cpm.v3 = cpdCovert ? (val / cpdCovert).toFixed(2) : '请勾选点位'
        } else if (type == 'v2') {
          this.cpm.v1 = (val * cpmCovert).toFixed(2)
          this.cpm.v3 = cpdCovert ? ((this.cpm.v1 - 0) / cpdCovert).toFixed(2) : 0
        } else if (type == 'v3') {
          this.cpm.v1 = (val * cpdCovert).toFixed(2)
          this.cpm.v2 = cpmCovert != 0 ? ((this.cpm.v1 - 0) / cpmCovert).toFixed(2) : 0
        }
      })
    },
    handleValue (item, type) {
      let cpmUnit = this.cpmUnit ? this.cpmUnit : 0
      let daysNum = this.daysNum ? this.daysNum : 0
      let deviceNum = this.deviceNum ? this.deviceNum : 0

      // if (type == 0) {
      //   this[item].v1 = 0;
      //   this[item].v2 = 0;
      //   return
      // }
      // if (item == 'cpm') {
      //   if (cpmUnit == 0 || daysNum == 0) {
      //     this[item].v1 = 0;
      //     this[item].v2 = 0;
      //     return
      //   }

      //   if (type == 1) {
      //     this[item].v2 = ((this[item].v1 - 0) / (cpmUnit * daysNum)).toFixed(2)
      //   } else {
      //     this[item].v1 = ((this[item].v2 - 0) * cpmUnit * daysNum).toFixed(2)
      //   }
      // } else if (item == 'cpd') {
      //   if (cpmUnit == 0 || daysNum == 0) {
      //     this[item].v1 = 0;
      //     this[item].v2 = 0;
      //     return
      //   }

      //   if (type == 1) {
      //     this[item].v2 = ((this[item].v1 - 0) / (deviceNum * daysNum)).toFixed(2)
      //   } else {
      //     this[item].v1 = ((this[item].v2 - 0) * deviceNum * daysNum).toFixed(2)
      //   }
      // }
    },
    reset () {
      this.cpm = { v1: '', v2: '', v3: '' }
    }
  }
}
</script>

<style lang="scss" scoped>
.clear {
  clear: both;
}
.left_input {
  width: 136px;
  ::v-deep input {
    width: 100px;
    border-radius: 4px;
  }
}
.right_input {
  width: 150px;
  ::v-deep input {
    width: 80px;
    border-radius: 4px;
  }
}
.convert_dialog {
  ::v-deep .el-dialog {
    .el-dialog__header {
      padding: 10px 0;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      .el-dialog__headerbtn {
        top: 15px;
      }
    }
    .el-dialog__body {
      background: #F5F5F5;
      padding: 20px 18px;
      .el-input-group__append {
        padding: 0 5px;
        background-color: #fff;
        border: none;
        color: #282729;
      }
    }
    .el-dialog__footer {
      text-align: center;
      padding: 10px;
    }
  }
  ::v-deep .el-input {
    float: left;
    input {
      text-align: center;
      color: #421EEF;
      padding: 0;
    }
  }
}
.ctn {
  background: #fff;
  border-radius: 4px;
  .tip {
    padding: 10px 20px;
    border-bottom: 1px solid #e9e9e9;
    line-height: 30px;
    ::v-deep .el-button {
      border: 1px solid #FF3973;
      color: #FF3973;
      width: 80px;
      &:hover {
        background: #fff;
      }
    }
  }
  .main {
    padding: 0 20px 50px;
    .title {
      color: #282729;
      font-weight: 600;
      line-height: 1.5;
      font-size: 16px;
      margin-top: 30px;
    }
    .sub {
      color: #999;
      font-size: 12px;
      line-height: 3;
    }
  }
}
</style>
